const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  label: {
    marginRight: theme.spacing(1),
  },
  editButton: {
    padding: theme.spacing(0, 1.5),
    minWidth: 'auto',
  },
  date: {
    fontSize: 14,
  },
});

export default styles;
